import type { IconData } from '@stacksjs/iconify-core'

export const locationPinDisabledFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M4.5 21C4.5 10.23 13.23 1.5 24 1.5S43.5 10.23 43.5 21c0 6.987-3.606 12.865-7.526 17.203c-3.932 4.351-8.326 7.316-10.237 8.506a3.26 3.26 0 0 1-3.474 0c-1.91-1.19-6.305-4.155-10.237-8.506C8.106 33.865 4.5 27.987 4.5 21M24 29a8 8 0 1 0 0-16a8 8 0 0 0 0 16\"/><path fill=\"#2859c5\" d=\"M2.232 2.232a2.5 2.5 0 0 1 3.536 0l40 40a2.5 2.5 0 0 1-3.536 3.536l-40-40a2.5 2.5 0 0 1 0-3.536\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPinDisabledFlat
